module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp2_6000.e7c4f504.png";